import { render } from "./reorder_point.vue?vue&type=template&id=891b84c6&scoped=true"
import script from "./reorder_point.vue?vue&type=script&lang=js"
export * from "./reorder_point.vue?vue&type=script&lang=js"

import "./reorder_point.vue?vue&type=style&index=0&id=891b84c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891b84c6"]])

export default __exports__